export default __webpack_public_path__ + "static/media/App translation file with excel functions.68624061.xlsx";